import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollReset = ({ children }) => {
    const { pathname } = useLocation();

    useLayoutEffect(() => {
        // Hard reset scroll position
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [pathname]);

    return null;
};

export default ScrollReset;
